import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canView } from "../lib/permissions";

export const ProtectedRoute = ({ children, adminOnly = false, seccion = null }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm tracking-wider uppercase">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (seccion && !canView(user, seccion)) return <Navigate to="/" replace />;
  return children;
};
